import React from 'react'
import axios from 'axios'

import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline'
import SimpleTable from '../../../shared/SimpleTable/SimpleTable'
import SimplePopUp from '../../../shared/SimplePopUp/SimplePopUp'
import SimpleDeletePopUp from '../../../shared/SimpleDeletePopUp/SimpleDeletePopUp'
import CustomFieldsForm from './CustomFieldsForm'
import AlertMessage from '../../../shared/Notify/AlertMessage'
import ProgressBar from '../../../shared/ProgressBar/ProgressBar'
import ErrorPage from '../../../shared/ErrorPage/ErrorPage'

class Customfields extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      model: 'Case Custom Field',
      custom_fields: [],
      openPopup: false,
      openDeletePopup: false,
      custom_field: {},
      initialGroup: { uid: '', attr_name: '', attr_type: '', klass: 1 },
      title: '',
      load: false,
      tableHead: ['attr_name', 'attr_type'],
      withShow: false,
      withEdit: true,
      maxWidth: 'sm',
      error_messages: '',
      error_messages_type: '',
      isOpen: false,
      message: '',
      type: '',
      loadCasesCustomFieldsError: null
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleDeleteItem = this.handleDeleteItem.bind(this)
    this.handleCreateorUpdateItem = this.handleCreateorUpdateItem.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleOpenDeletePopup = this.handleOpenDeletePopup.bind(this)
    this.handleDeleteClose = this.handleDeleteClose.bind(this)
  }

  componentDidMount() {
    this.loadCustomFields(
      process.env.REACT_APP_API_DOMAIN + '/v1/legal_cases/custom_fields'
    )
  }

  loadCustomFields(url) {
    axios({
      method: 'get',
      url: url,
      headers: { 'X-APP-API-KEY': localStorage.getItem('api_key') }
    })
      .then((resp) => {
        this.setState({ custom_fields: resp.data })
        this.setState({ load: true })
      })
      .catch((error) =>
        this.setState({ loadCasesCustomFieldsError: error.response.status })
      )
  }

  handleSubmit() {
    this.setState({ error_messages_type: '' })
    const item = this.state.custom_field
    var method = ''
    var url = ''
    if (item.uid === '') {
      method = 'post'
      url = process.env.REACT_APP_API_DOMAIN + '/v1/custom_fields/'
    } else {
      method = 'put'
      url = process.env.REACT_APP_API_DOMAIN + '/v1/custom_fields/' + item.uid
    }
    axios({
      method: method,
      url: url,
      data: item,
      headers: { 'X-APP-API-KEY': localStorage.getItem('api_key') }
    })
      .then((resp) => {
        console.log(resp.data)
        const newData = resp.data
        this.setState({
          custom_fields: this.state.custom_fields.filter(
            (custom_field) => custom_field.uid !== item.uid
          )
        })
        this.setState({ custom_fields: [...this.state.custom_fields, newData] })
        this.setState({
          isOpen: true,
          message: 'Submitted Successfully',
          type: 'success'
        })
        this.setState({ openPopup: false })
      })
      .catch((error) => {
        if (error.response.status === 422) {
          if (error.response.data.errors.attr_type !== undefined) {
            this.setState({
              error_messages_type:
                'Attribute type ' + error.response.data.errors.attr_type[0]
            })
          } else {
            this.setState({
              error_messages:
                'Attribute Name ' + error.response.data.errors.attr_name[0]
            })
          }
        } else {
          this.setState({
            isOpen: true,
            message:
              error.response.status.toString() +
              ' Unexpected Error Problem Occurred',
            type: 'error'
          })
          this.setState({ openPopup: false })
        }
      })
  }

  handleDeleteItem() {
    const DeleteItemId = this.state.custom_field.uid
    axios({
      method: 'delete',
      url:
        process.env.REACT_APP_API_DOMAIN + '/v1/custom_fields/' + DeleteItemId,
      headers: { 'X-APP-API-KEY': localStorage.getItem('api_key') }
    })
      .then(() => {
        this.setState({
          custom_fields: this.state.custom_fields.filter(
            (item) => item.uid !== DeleteItemId
          )
        })
        this.setState({
          isOpen: true,
          message: 'Deleted Successfully',
          type: 'error'
        })
        this.setState({ openDeletePopup: false })
      })
      .catch((error) => console.log(error.response))
  }

  handleClose() {
    this.setState({ openPopup: false })
    this.setState({ openDeletePopup: false })
    this.setState({ error_messages: '' })
  }

  handleCreateorUpdateItem(item, isAdd, model) {
    var textTitle = ''
    if (isAdd) {
      textTitle = 'Create ' + model
    } else {
      textTitle = 'Edit ' + model
    }
    this.setState({ openPopup: true })
    this.setState({ custom_field: item })
    this.setState({ title: textTitle })
  }

  handleInputChange(e) {
    console.log(e.target.name)
    console.log(e.target.value)

    this.setState({
      custom_field: {
        ...this.state.custom_field,
        [e.target.name]: e.target.value
      }
    })
  }

  handleOpenDeletePopup(item, model) {
    this.setState({ model: model })
    this.setState({ custom_field: item })
    this.setState({ openDeletePopup: true })
  }

  handleDeleteClose() {
    this.setState({ openDeletePopup: false })
  }

  render() {
    const { load, loadCasesCustomFieldsError } = this.state

    return (
      <>
        {load && !loadCasesCustomFieldsError ? (
          <div>
            <SimpleTable
              handleClick={this.handleCreateorUpdateItem}
              initialItem={this.state.initialGroup}
              items={this.state.custom_fields}
              model={this.state.model}
              onOpenDeletePopup={this.handleOpenDeletePopup}
              headers={this.state.tableHead}
              withShow={this.state.withShow}
              withEdit={this.state.withEdit}
              icon={<PeopleOutlineIcon fontSize="large" />}
            />
            <SimplePopUp
              openPopup={this.state.openPopup}
              title={this.state.title}
              items={this.state.custom_fields}
              handleClose={this.handleClose}
              maxWidth={this.state.mdWidth}
            >
              <CustomFieldsForm
                error={this.state.error_messages}
                errorType={this.state.error_messages_type}
                item={this.state.custom_field}
                submit={this.handleSubmit}
                onchange={this.handleInputChange}
              />
            </SimplePopUp>
            <AlertMessage
              notify={this.state.notify}
              handleCloseAlert={this.handleCloseAlert}
              isOpen={this.state.isOpen}
              type={this.state.type}
              message={this.state.message}
            />
            <SimpleDeletePopUp
              openDeletePopup={this.state.openDeletePopup}
              item={this.state.custom_field}
              delete={this.handleDeleteItem}
              handleDeleteClose={this.handleClose}
              model={this.state.model}
            />
          </div>
        ) : loadCasesCustomFieldsError ? (
          <ErrorPage type={loadCasesCustomFieldsError} />
        ) : (
          <ProgressBar model="Custom Legal Case" />
        )}
      </>
    )
  }
}

export default Customfields
